import { Image } from '@atoms/index';

const TaxInsightsButton = ({
    id = '',
    buttonText = '',
    onClick = () => {},
    disabled = false,
    suffix = false,
    width = '',
    suffixRender = (
        <Image
            src="/images/tax-optimiser/right-arrow.svg"
            className="w-5 h-5"
        />
    ),
    prefix = false,
    prefixRender = (
        <Image
            src="/images/tax-optimiser/right-arrow.svg"
            className="w-5 h-5 rotate-180"
        />
    ),
    rounded = 'rounded-lg',
    buttonType = 'primary',
    size = 'regular',
    className = '',
    customBackground = '',
    customBackgroundWrapper = '',
    wrapperClassName = '',
    type = 'button',
    isLoading = false,
}) => {
    const getBackgroundWrapper = (buttonType) => {
        switch (buttonType) {
            case 'primary':
                return customBackgroundWrapper || 'bg-tax-optimizer-button-border';
            case 'secondary':
                return customBackgroundWrapper || 'bg-tax-optimizer-button-border';
        }
    };

    const getBackgroundButton = (buttonType) => {
        switch (buttonType) {
            case 'primary':
                return customBackground || 'bg-tax-optimizer-button';
            case 'secondary':
                return customBackground || `bg-basicBlack`;
        }
    };

    const getButtonSize = (size) => {
        switch (size) {
            case 'regular':
                return 'px-4 py-2';
            case 'large':
                return 'px-6 py-3';
        }
    };

    const buttonClicked = (e) => {
        if (!disabled && !isLoading && onClick) onClick(e);
    }

    return (
        <div
            className={`${
                !disabled ? `p-[1px] ${getBackgroundWrapper(buttonType)}` : ''
            } ${rounded} ${width} ${wrapperClassName}`}
        >
            <button
                id={id}
                className={`${
                    !disabled ? `${getBackgroundButton(buttonType)} cursor-pointer p5-semibold xl:p5-medium`
                        : 'bg-tax-optimizer-button-disabled cursor-not-allowed border border-gray-600 p5-medium'
                } ${disabled ? 'text-gray-400' : 'text-primary-20'} ${getButtonSize(
                    size
                )} ${rounded} flex gap-2 items-center w-full justify-center ${className}`}
                onClick={buttonClicked}
                disabled={disabled || isLoading}
                type={type}
            >
                {prefix ? prefixRender : null}
                {buttonText}
                {isLoading ? (
                    <div className={'button-loader-white'} />
                ) : (
                    suffix ? suffixRender : null
                )}
            </button>
        </div>
    );
};

export default TaxInsightsButton;
